import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';

const GSTLoader = ({ children }) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1500); 

    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return (
      <Box
        sx={{
          height: '100vh',
          width: '100%',
          bgcolor: '#f4f9ff',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
          gap: 2,
        }}
      >

        <Box
          component="img"
          src="Images/loader.png" 
          alt="GST Loader"
          sx={{
            width: 150,
            height: 100,
            animation: 'spin 2s linear infinite',
            '@keyframes spin': {
              '0%': { transform: 'rotate(0deg)' },
              '100%': { transform: 'rotate(360deg)' },
            },
          }}
        />

        <Typography
          variant="h6"
          sx={{
            color: '#004080',
            fontWeight: 500,
            fontFamily: "'Poppins', sans-serif",
          }}
        >
          Loading GST Services...
        </Typography>
      </Box>
    );
  }

  return <>{children}</>;
};

export default GSTLoader;
